var React = require('react');

function ChatThink (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#70A4CE","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M14.81 63.379a77.384 77.384 0 0121.753-10.022H59.4c3.53 0 6.724-1.43 9.037-3.743a12.74 12.74 0 003.743-9.037V15.335c0-3.529-1.43-6.724-3.743-9.036A12.74 12.74 0 0059.4 2.555H15.12A12.74 12.74 0 006.083 6.3a12.74 12.74 0 00-3.743 9.036v25.242c0 3.12 1.118 5.98 2.977 8.2a12.747 12.747 0 009.493 4.576v10.026z","strokeWidth":"4.68","key":0}),React.createElement("text",{"strokeWidth":".5","fontFamily":"ArialRoundedMTBold, Arial Rounded MT Bold","fontSize":"30.096","letterSpacing":"-.297","fill":"#70A4CE","transform":"translate(0 .215)","key":1},React.createElement("tspan",{"x":"28.783","y":"35.92"},"?"))]));
}

ChatThink.defaultProps = {"width":"75","height":"68"};

module.exports = ChatThink;

ChatThink.default = ChatThink;
